import { Empty } from "@arco-design/web-react";
import EmptyIcon from "@/assets/ai-factory/empty-data.png";
interface AiEmptyProps {
  description?: React.ReactNode | string;
}
const AiEmpty: React.FC<AiEmptyProps> = (props) => {
  const { description = "暂无数据" } = props;
  return <Empty icon={<img style={{ width: 174, height: 125 }} src={EmptyIcon} alt="" />} description={description} />;
};
export default AiEmpty;
